import { VFlow } from 'bold-ui'
import React from 'react'
import { AcompanhamentoVulnerabilidadeSection } from 'view/atendimentos/detail/soap/aside/acompanhamento-vulnerabilidade/AcompanhamentoVulnerabilidadeSection'
import { IdadeGestacionalAcompanhamentoPreNatal } from 'view/atendimentos/detail/soap/aside/pre-natal/model-acompanhamentoPreNatal'

import { InformacoesGestacaoAtualCard } from './InformacoesGestacaoAtualCard'
import { ListaProblemasCondicoesCard } from './ListaProblemasCondicoesCard'
import { MedicamentosEmUsoCard } from './MedicamentosEmUsoCard'

interface InformacoesGestacaoTabContentProps {
  cidadaoId: ID
  prontuarioId: ID
  dataReferencia: Instant
  loading: boolean
  dum: Date
  idadeGestacional: IdadeGestacionalAcompanhamentoPreNatal
  dataInicioGestacao: Date
  dppEcografica: Date
  quantidadeConsultas: number
  dataPrimeiraConsulta: LocalDate
  dataUltimaConsulta: LocalDate
}

export const InformacoesGestacaoTabContent = (props: InformacoesGestacaoTabContentProps) => {
  const {
    cidadaoId,
    prontuarioId,
    loading,
    dataReferencia,
    dum,
    idadeGestacional,
    dataInicioGestacao,
    dppEcografica,
    quantidadeConsultas,
    dataPrimeiraConsulta,
    dataUltimaConsulta,
  } = props

  return (
    <VFlow>
      <InformacoesGestacaoAtualCard
        cidadaoId={cidadaoId}
        loading={loading}
        dum={dum}
        idadeGestacional={idadeGestacional}
        dataInicioGestacao={dataInicioGestacao}
        dppEcografica={dppEcografica}
        quantidadeConsultas={quantidadeConsultas}
        dataPrimeiraConsulta={dataPrimeiraConsulta}
        dataUltimaConsulta={dataUltimaConsulta}
      />
      <AcompanhamentoVulnerabilidadeSection
        cidadaoId={cidadaoId}
        dataReferencia={dataReferencia}
        isAcompanhamentoPreNatal
      />
      <MedicamentosEmUsoCard prontuarioId={prontuarioId} />
      <ListaProblemasCondicoesCard prontuarioId={prontuarioId} dataInicioGestacao={dataInicioGestacao} />
    </VFlow>
  )
}
